import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { Header, Footer } from "./components/Layout";
import { Toaster } from "./components/ui/sonner";
import HomePage from "./pages/HomePage";
import FleetPage from "./pages/FleetPage";
import CarDetailPage from "./pages/CarDetailPage";
import BookingSuccessPage from "./pages/BookingSuccessPage";
import BookingConfirmedPage from "./pages/BookingConfirmedPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import AdminPage from "./pages/AdminPage";

function App() {
  return (
    <LanguageProvider>
      <div className="App min-h-screen bg-background text-foreground">
        <BrowserRouter>
          <Header />
          <main className="min-h-screen">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/fleet" element={<FleetPage />} />
              <Route path="/car/:id" element={<CarDetailPage />} />
              <Route path="/booking/success" element={<BookingSuccessPage />} />
              <Route path="/booking/confirmed/:id" element={<BookingConfirmedPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/admin" element={<AdminPage />} />
            </Routes>
          </main>
          <Footer />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
